import * as React from 'react';

import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Header from "../components/Header";

import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import { useSync } from '../context/SyncingProvider';
import { useMessage } from '../context/MessageProvider';
import { useAuth } from '../context/AuthProvider';

import { uploadLocalStorage } from '../utils/upload';
import { truncateLocalData } from '../utils/utils';

import { useConnectivity } from '../context/ConnectivityProvider';
import { useConfirmationDialog } from '../context/ConfirmationDialogContext';

/*
// if you need to load data, you can use this template, note that the return value needs to be an object with named records in it.
export async function loader() {
    return {objectname: {}};
}
*/


export default function SyncPage({title = "Sync",...props}) {
    const { setSuccess, setError, setMessage} = useMessage();
    const {isOnline} = useConnectivity();
    const { performSync, isSyncing } = useSync();
    const { user } = useAuth();

    const [working, setWorking] = React.useState(false);

    const {confirm} = useConfirmationDialog();


    const handleSyncClick = async () => {
        if (isOnline) {
            try {
                await performSync();
                setSuccess("Sync completed successfully!");
            } catch (error) {
                // Handle error if needed
                console.error(error);
                setError("Sync failed. Please try again.");
            }
        } else {
            setMessage("Sync is disabled while offline");
        }
    };

    const handleFullSyncClick = async () => {
        if (isOnline) {
            try {
                await performSync(true);
                setSuccess("Sync completed successfully!");
            } catch (error) {
                // Handle error if needed
                console.error(error);
                setError("Sync failed. Please try again.");
            }
        } else {
            setMessage("Sync is disabled while offline");
        }
    };

    const handleLocalClearFullSyncClick = async () => {
        if (isOnline) {
            try {

                confirm({
                    title: "Clear Local Data and Sync?",
                    message: <p style={{margin:0}}>
                        You are about to clear all local data on this device and then perform a full sync from the server to restore data.
                        <br/>
                        Are you sure?
                    </p>,
                    onSubmit: async () => {
                        // do upload
                        const uploadResults = await uploadLocalStorage({user});
                        console.log("upload results", uploadResults);

                        // do clear
                        await truncateLocalData();

                        // do full sync
                        await performSync(true);
                        setSuccess("Local Clear and Sync completed successfully!");
                    },
                });
            } catch (error) {
                // Handle error if needed
                console.error(error);
                setError("Sync failed. Please try again.");
            }
        } else {
            setMessage("Sync is disabled while offline");
        }
    };

    const onUploadClick = async () => {
        try {
            setWorking(true);
            const uploadResults = await uploadLocalStorage({user});
            console.log("upload results", uploadResults);

            setSuccess("Data uploaded to DB");
        }
        catch(e){
            console.error(e);
            setError("Error uploading data to DB");
        } finally {
            setWorking(false);
        }
    };

    // note you can play with the container maxwidth to spread out the window content appears in
    return (
        <Container component="main" maxWidth="sm">
            <Header label={title} />

            {isOnline && 
                <Grid container spacing={2}>
                    <Grid xs={12}> 
                        <Button fullWidth variant="contained" onClick={handleSyncClick} disabled={isSyncing}>Sync from last sync point</Button>
                    </Grid>
                    <Grid xs={12}> 
                        <Button fullWidth variant="contained" onClick={handleFullSyncClick} disabled={isSyncing}>Full Sync</Button>
                    </Grid>
                    <Grid xs={12}> 
                        <Button fullWidth variant="contained" onClick={handleLocalClearFullSyncClick} disabled={isSyncing}>Local Clear and Full Sync</Button>
                    </Grid>
                    <Grid xs={12}> 
                        <Button fullWidth variant="contained" onClick={onUploadClick} disabled={working}>Upload data to DB</Button>
                    </Grid>
                </Grid>
            }
            {!isOnline && <Typography>Currenly Offline</Typography>}
        </Container>
    );
}